import { commentApiSlice, type ICommentType } from '../services/commentsApiSlice';

export const useCreateNewComment = () => {
  const [mutate, createNewCommentResult] = commentApiSlice.useCreateNewCommentMutation({
    fixedCacheKey: 'use-create-new-comment-api',
  });

  const triggerCreateNewComment = (commentData: ICommentType, nextReviewDate: string | null) => {
    return mutate({ comment: commentData, nextReviewDate });
  };

  return {
    createNewCommentResult,
    triggerCreateNewComment,
  };
};
